import React from "react";

export function PageHeader({ title, subtitle, actions, eyebrow }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
      <div>
        {eyebrow && (
          <div className="text-[10px] uppercase tracking-[0.2em] text-emerald-800 font-semibold mb-1.5">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">
          {title}
        </h1>
        {subtitle && <p className="text-sm text-gray-600 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}

export function Badge({ children, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-100 text-slate-800 border-slate-200",
    emerald: "bg-emerald-100 text-emerald-800 border-emerald-200",
    amber: "bg-amber-100 text-amber-800 border-amber-200",
    red: "bg-red-100 text-red-800 border-red-200",
    blue: "bg-blue-100 text-blue-800 border-blue-200",
    gray: "bg-gray-100 text-gray-700 border-gray-200",
  };
  return (
    <span
      className={`inline-flex items-center text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full border ${
        tones[tone] || tones.slate
      }`}
    >
      {children}
    </span>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <div className="bg-white border border-dashed border-gray-300 rounded-md p-10 text-center">
      <div className="font-display text-lg font-semibold text-gray-900">{title}</div>
      {hint && <p className="text-sm text-gray-600 mt-1.5 max-w-md mx-auto">{hint}</p>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}

export function priorityTone(p) {
  return { critical: "red", high: "amber", medium: "blue", low: "emerald" }[p] || "slate";
}
export function statusTone(s) {
  if (!s) return "slate";
  return {
    open: "amber", in_progress: "blue", escalated: "red",
    resolved: "emerald", closed: "gray",
    requested: "amber", scheduled: "blue", completed: "emerald",
    active: "emerald", inactive: "gray",
    in_use: "emerald", idle: "amber", maintenance: "blue", disposed: "gray",
  }[s] || "slate";
}
